import { render, staticRenderFns } from "./WatchDogNotificationArea.vue?vue&type=template&id=adbe4708&scoped=true"
import script from "./WatchDogNotificationArea.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchDogNotificationArea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbe4708",
  null
  
)

export default component.exports